/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconMail({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconMail">  <path fill="currentColor" d="M221 88.8V196H35V88.2c1.5 1.1 93 64.3 93 64.3l93-63.7zm-93 48.4l93-62.4V60H35v13.5c12.4 9.3 52.7 38.1 93 63.7z" /></svg>
  );
}

IconMail.propTypes = iconPropTypes;
IconMail.defaultProps = iconDefaultProps;
